<!--
 * @Author: guoyu
 * @Date: 2020-09-17 11:17:57
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-05 11:15:22
 * @Description: b端退款
-->
<template>
  <div class="refuse-refound" ref="refRefound">
    <div id="refuse-item" class="refuse-item">
      <div class="item-label">{{$t('components_order_refuse_refound_648')}}</div>
      <el-select
        class="reason-picker-val input-tip"
        v-model="refoundReson.value"
        :placeholder="$t('components_order_refuse_refound_649')"
      >
        <el-option
          v-for="item in reasonList"
          :key="item.value"
          :label="item.text"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="refuse-item">
      <div class="item-label mg-b-24">{{$t('components_order_refuse_refound_650')}}</div>
      <FpsTextArea
        class="reason-text"
        v-model="reasonDetail"
        :placeholder="$t('components_order_refuse_refound_651')"
        @focus="handleExtra"
        @blur="isFixed = 'fixed'"
      ></FpsTextArea>
    </div>
    <div class="refuse-item">
      <div class="item-label mg-b-24">{{$t('components_order_c_order_round_603')}}<span class="input-tip">{{$t('components_order_c_order_round_601')}}</span>
      </div>
      <UploadImg class="reason-imgs" v-model="images" :max="5"></UploadImg>
    </div>
    <div class="refound-footer" :style="{ position: isFixed }">
      <div
        class="refound-submit"
        :class="{ 'allow-submit': allowSubmit }"
        @click="refuseRefound"
      >{{$t('components_order_refuse_refound_652')}}</div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import UploadImg from '@/components/common/upload/upload-image';
import FpsTextArea from '@/components/common/input/text-area';
export default {
  props: {
    orderNo: {
      type: String,
      default: () => {
        return '';
      },
    },
  },
  components: {
    UploadImg,
    FpsTextArea,
  },
  data() {
    return {
      refoundReson: {
        value: '',
      },
      reasonDetail: '',
      orderInfo: '',
      popupOpen: false,
      images: [],
      reasonList: [
        { text: i18n.t('filters_index_87'), value: 'COMPLETED' },
        { text: i18n.t('filters_index_88'), value: 'USER_MALICIOUS_REFUND' },
        { text: i18n.t('filters_index_89'), value: 'OTHER' },
      ],
      isFixed: 'absolute', // 用於處理部分機型按鈕擋住輸入框的情況
    };
  },
  computed: {
    comImages(){
      return this.images.length===0?'':this.images
    },
    allowSubmit() {
      return ['reasonDetail', 'refoundReson.value', 'comImages'].every((key) => {
        return this.$util.getVal(this, key);
      });
    },
    userInfo() {
      return this.$store.state.user.userInfo || {};
    },
  },
  methods: {
    checkNull() {
      return [
        { key: 'reasonDetail', msg: i18n.t('components_order_refuse_refound_653') },
        { key: 'refoundReson.value', msg: i18n.t('components_order_refuse_refound_654') },
        { key: 'comImages', msg: i18n.t('components_order_refuse_refound_655') }
      ].some((item) => {
        const { key, msg } = item;
        if (!this.$util.getVal(this, key)) {
          this.$toast(msg);
          return true;
        }
      });
    },
    refuseRefound() {
      if (this.checkNull() || this.refounding) return;
      this.refounding = true;
      this.$http
        .post('/tradeRefund/reject/player', {
          uuid: this.orderNo,
          rejectReason: this.refoundReson.value,
          rejectDesc: this.reasonDetail,
          rejectImages: this.images,
        })
        .then(() => {
          this.refounding = false;
          this.$emit('goToborderDetail', 'borderRoundDetail');
        })
        .catch(() => {
          this.refounding = false;
        });
    },
    handleExtra() {
      this.isFixed = '';
      setTimeout(() => {
        this.$refs.refRefound.scrollTo(0, 0);
      }, 300);
    },
  },
};
</script>
<style lang="scss" scoped>
.refuse-refound {
  height: auto;
  overflow-y: auto;
  padding-bottom: 113px;
  /deep/ .btn-back {
    font-size: 15px !important;
    line-height: 21px !important;
    color: #666666;
  }
}
.refuse-title {
  border-bottom: 1px solid #dddddd;
}
.refuse-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 18px 30px;
  font-size: 15px;
  color: #333333;
  line-height: 21px;
}
.item-label {
  font-weight: 500;
}
.refound-amount {
  color: #fe7f38;
}
.reason-text {
  width: 100%;
}
.reason-imgs {
  width: 100%;
}
.mg-b-24 {
  margin-bottom: 12px;
}
.input-tip {
  font-weight: 400;
  color: #8c94aa;
}
.picker-arrow {
  vertical-align: middle;
  font-weight: 700;
}
.reason-picker-val {
  font-size: 14px;
}
.refound-footer {
  width: 375px;
  bottom: 0;
  padding: 15px 16px 30px;
  background: #ffffff;
}
.refound-submit {
  width: 100%;
  height: 48px;
  text-align: center;
  line-height: 48px;
  font-weight: 500;
  font-size: 16px;
  color: rgba(99, 109, 134, 0.3);
  background: #f1f4f6;
  border-radius: 25px;
}
.no-count {
  font-weight: 400;
  color: #8c94aa;
}
.allow-submit {
  cursor: pointer;
  background: $color-main;
  color: #ffffff;
}
</style>
<style lang="scss">
.refuse-refound {
  .reason-picker-val {
    font-size: 14px;
    .el-input__inner {
      border: none;
      text-align: right;
    }
    .el-input__inner::-webkit-input-placeholder {
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>